export const USERS_PER_PAGE = 20;

export const USER_TYPE = {
    Admin: 1,
    Customer: 2,
}



// WEBPACK FOOTER //
// ./app/web/src/constants/user.js